module.exports = __webpack_public_path__ + "img/us_qrcode.1cf7267f.jpg";